
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/app/core/services/auth.service';
import { getPath, PathUnit } from '@/app/consts/path.const';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  const router = inject(Router);

 return authService.checkLoggedIn().then(isLoggedIn => {
    if (isLoggedIn) {
      return true;
    } else {
      router.navigate([`/${getPath(PathUnit.Login)}`]);
      return false;
    }
  });
};